<template>
  <section class="videos-section">
    <div class="container">
      <div
        class="videos-section__header flex justify-between items-center mb-4"
      >
        <h2 class="text-xl md:text-2xl text-[#222] m-0 font-bold">
          {{ $t("media.videoContent") }}
        </h2>
        <div class="videos-section__navigation">
          <button
            @click="swiper.slidePrev()"
            :class="{ disabled: !canSlidePrev }"
          >
            <svg-icon name="left" />
          </button>
          <button
            @click="swiper.slideNext()"
            :class="{ disabled: !canSlideNext }"
          >
            <svg-icon name="right" />
          </button>
        </div>
      </div>

      <swiper
        :slides-per-view="1"
        :space-between="20"
        :breakpoints="breakpoints"
        :pagination="{ clickable: true }"
        class="videos-section__slider"
        @swiper="onSwiper"
      >
        <swiper-slide v-for="(video, index) in videos" :key="index">
          <div @click="goToVideo(video.id)" class="videos-section__card">
            <div class="videos-section__preview">
              <img
                :src="video.image"
                :alt="video.title"
                class="w-full aspect-[3/2] object-cover"
              />
              <button class="videos-section__play-btn">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M12 8L24 16L12 24V8Z" fill="#05B242" />
                </svg>
              </button>
            </div>
            <h3 class="videos-section__video-title">
              {{ video.title }}
            </h3>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { mediaService } from "@/services";
// import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default {
  name: "VideosSection",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      breakpoints: {
        320: {
          slidesPerView: 1.2,
        },
        640: {
          slidesPerView: 1.7,
        },
        1024: {
          slidesPerView: 2.5,
          slidesPerGroup: 1,
        },
      },
      videos: [],
      swiper: null,
      canSlidePrev: false,
      canSlideNext: true,
      //   SwiperAutoplay: Autoplay,
      //   SwiperPagination: Pagination,
    };
  },
  mounted() {
    this.getVideos();
  },
  methods: {
    getVideos() {
      mediaService.getMedia("video", { limit: 10 }).then((response) => {
        console.log(response);
        this.videos = response.results;
        this.canSlideNext = true;
      });
    },
    onSwiper(swiper) {
      this.swiper = swiper;

      swiper.on("slideChange", () => {
        this.canSlidePrev = !swiper.isBeginning;
        this.canSlideNext = !swiper.isEnd;
      });
    },
    goToVideo(id) {
      this.$router.push({
        name: "video_view",
        params: { id },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.videos-section {
  @apply bg-white py-2;

  &__header {
  }

  &__title {
    @apply text-[#222];
  }

  &__navigation {
    @apply flex items-center gap-2;
    button {
      @apply w-10 h-10 rounded-full bg-white flex items-center justify-center;
      @apply transition-all duration-300 bg-zinc-100;
      &.disabled {
        @apply opacity-50 cursor-not-allowed;
      }
    }
  }

  &__card {
    @apply flex flex-col;
  }

  &__preview {
    @apply relative overflow-hidden rounded-3xl bg-[#F1F1F1];
  }

  &__play-btn {
    @apply transition-all duration-300 hover:bg-white;
    @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/80 flex items-center justify-center;
  }

  &__video-title {
    @apply text-[#222] mt-4 text-base lg:text-lg font-semibold leading-5 lg:leading-6;
  }

  :deep(.swiper-pagination) {
    @apply bottom-0;
  }

  :deep(.swiper-pagination-bullet) {
    @apply w-2 h-2 bg-[#F1F1F1] opacity-100;
  }

  :deep(.swiper-pagination-bullet-active) {
    @apply bg-[#05B242];
  }
}
</style>
